/**
 * Legacy AdministrationApiService module — preserved as an empty AngularJS
 * module so existing dependencies (`acme.common.service.administrationApi`)
 * keep resolving.
 *
 * The actual AdministrationApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/administration/administration-api.service.ts
 */
angular.module("acme.common.service.administrationApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
